// extracted by mini-css-extract-plugin
export default {"overlay":"TemporaryOverlay_overlay__pA6gx"};